<template>
  <connect-wallet v-if="showConnectWallet" />
  <mint v-else :collection="collection" :mint="openPurchase" />
</template>

<script>
import { mapState, mapActions } from 'vuex'
import Mint from './Mint.vue'
import ConnectWallet from './ConnectWallet.vue'

export default {
  components: {
    Mint,
    ConnectWallet,
  },
  props: ['collection'],
  computed: {
    ...mapState({
      showConnectWallet: function(state) {
        return !state.auth.account.isConnected
      }
    }),
  },
  methods: {
    ...mapActions('drops', ['openPurchase'])
  }
}
</script>

<style scoped lang="scss">

</style>
